import { render, staticRenderFns } from "./CommentTable.vue?vue&type=template&id=34198ebc&scoped=true&"
import script from "./CommentTable.vue?vue&type=script&lang=ts&"
export * from "./CommentTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommentTable.vue?vue&type=style&index=0&id=34198ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34198ebc",
  null
  
)

export default component.exports